import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const predictionFieldContainer = style([
  {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    gap: space.s12,
    padding: `${space.s12}px 0`,
  },
]);

export const numericBadge = style([
  {
    selectors: {
      '&:is(&)': {
        ...typography.titleSm,
      },
    },
  },
]);

export const predictionFieldBody = style([
  {
    maxWidth: 524,
    marginRight: 'auto',
  },
]);
